import './button.scss';
import React from 'react';
function Button({t,text,handlerSelectModal}) {
  
  return (
    <button onClick={() =>
      
      handlerSelectModal()}>
        <span>{text}</span>
    </button>
  );
}

export default Button;